import { jsx as _jsx } from "react/jsx-runtime";
import './TS_EditableItemController.scss';
import { BadImplementationException, exists, resolveContent } from '@nu-art/ts-common';
import { EditableDBItemV3 } from '../../utils/EditableItem.js';
import { ComponentSync } from '../../core/ComponentSync.js';
/**
 * Item_EditorController class handles the editing of a specific db item
 * and encapsulate logic to load the item from the local cache and uses the EditableItem to
 * and TS_EditableContent for rendering and editing the db item.
 *
 * @template Proto - The database prototype def to be edited
 * @template Props - The Props this class component takes
 */
export class TS_EditableItemController extends ComponentSync {
    static DefaultAutoSave = (item) => {
        return !!item?._id;
    };
    constructor(p) {
        super(p);
        const method = p.module.defaultDispatcher.method;
        // @ts-ignore
        this[method] = this.__onItemUpdated;
    }
    __onItemUpdated = (...params) => {
        const itemId = this.state.editable.get('_id');
        if (!itemId)
            return;
        let updatedItem;
        if (!(params[0] === 'upsert-all' && (updatedItem = params[1].find(item => item._id === itemId))))
            return;
        this.state.editable?.setConflictingItem(updatedItem);
    };
    deriveStateFromProps(nextProps, state) {
        const _state = (state || {});
        let item = typeof nextProps.item === 'string' ? nextProps.module.cache.unique(nextProps.item) : nextProps.item;
        if (!exists(item))
            item = this.props.createInitialInstance?.();
        if (!item)
            throw new BadImplementationException('in order to use this component to create an item you need to provide a createInitialInstance callback');
        _state.editable = new EditableDBItemV3(item, nextProps.module, nextProps.onError)
            .setOnChanged(async (editable) => {
            this.setState({ editable });
        })
            .setAutoSave(resolveContent(nextProps.autoSave || TS_EditableItemController.DefaultAutoSave, item) || false)
            .setOnSaveCompleted(this.props.onSave);
        if (nextProps.saveAction)
            _state.editable.setSaveAction(nextProps.saveAction);
        return _state;
    }
    render() {
        const Editor = this.props.editor;
        return _jsx(Editor, { editable: this.state.editable, ...(this.props.editorProps || {}) });
    }
}
//# sourceMappingURL=TS_EditableItemController.js.map